import { useTranslation } from 'react-i18next';

interface ErrorStateProps {
    error: Error;
    onRetry: () => void;
    className?: string;
    title?: string;
}

export const ErrorState = ({
    error,
    onRetry,
    className = 'h-64',
    title,
}: ErrorStateProps) => {
    const { t } = useTranslation('withdrawalsModule');
    const displayTitle = title || t('errors.title');

    return (
        <div className={'flex items-center justify-center ' + className}>
            <div className="text-center">
                <div className="text-red-500 text-4xl mb-4">⚠️</div>
                <h3 className="text-lg font-semibold text-gray-800 mb-2">
                    {displayTitle}
                </h3>
                <p className="text-gray-600 mb-4">{error.message}</p>
                <button
                    onClick={onRetry}
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
                >
                    {t('buttons.retry')}
                </button>
            </div>
        </div>
    );
};

